//#region src/packlets/diagnostics/diagnostics-broadcast.ts
var createCollectDiagnosticsBroadcastSender = () => {
	return { broadcastDiagnosticsRequest: async () => void 0 };
};
var createCollectDiagnosticsBroadcastHandler = (_) => {
	return {
		start: () => {},
		stop: () => {}
	};
};
//#endregion
export { createCollectDiagnosticsBroadcastHandler, createCollectDiagnosticsBroadcastSender };

//# sourceMappingURL=diagnostics-broadcast.mjs.map